import { FsMatchemPointsRules } from "db/model/pickemDetails/Matchem/FsMatchemPointsRules";
import { MatchemPointsRules } from "model/PickemDetails/Matchem/PointsRules";

export const mapMatchemPointsRules = (
  fsModel: FsMatchemPointsRules
): MatchemPointsRules | undefined => {
  if (!fsModel.correct) {
    return undefined;
  }

  return {
    correct: fsModel.correct,
    matchPoint: fsModel.matchPoint,
  };
};
